var map = {
	"./Download1.svg": 6272,
	"./File.svg": 2694,
	"./Link.svg": 2827,
	"./Vector-1.svg": 5836,
	"./Vector.svg": 8630,
	"./activity.svg": 8100,
	"./add-circle.svg": 6937,
	"./ai-verified-badge.svg": 2972,
	"./arrow-left.svg": 7316,
	"./attach-money-1.svg": 1213,
	"./cardano-(ada).svg": 441,
	"./certified-professional-badge.svg": 5200,
	"./chevron-down.svg": 745,
	"./clock.svg": 5295,
	"./course-badge.svg": 1122,
	"./filter.svg": 7453,
	"./filter2.svg": 7957,
	"./fluent_flag-16-filled.svg": 3123,
	"./gallery.svg": 7743,
	"./grid-2-fill.svg": 6312,
	"./grid-2.svg": 1334,
	"./iconoir_list.svg": 9133,
	"./list-filled.svg": 3916,
	"./microphone-2.svg": 2078,
	"./options.svg": 1639,
	"./search-normal.svg": 3413,
	"./setting-filter.svg": 2388,
	"./sort.svg": 8243,
	"./task-square.svg": 7492,
	"./task_notes.svg": 4266,
	"./timeline-outline-sharp.svg": 2904,
	"./timeline-rounded.svg": 4402,
	"./vuesax/outline/microphone-2.svg": 3626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4771;